import Breadcrumb from "../utlis/Breadcrumb";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import HeadingPage from "../utlis/HeadingPage";
function Patroness() {
  return (
    <>
      {/* ================= HEADER ================= */}
      <Header />

      {/* ================= BREADCRUMB / INNER SLIDER ================= */}
      <div className="InnerSld">
        <Breadcrumb
          img="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/page-title.jpg"
          title="Our Patroness"
          title2=""
          parentTitle="About"
          path="Our Patroness"
        />
      </div>

      {/* ================= ABOUT CONTENT ================= */}
      <div className="innerbody">
        <div className="container-fluid">
          <div className="row about-grid align-items-stretch">
            {/* Left Content */}
            <div className="col-12 col-xl-8">
              <div className="contact-form-card">
                <h2 className="about-title"> Our Patroness</h2>

                <div className="about-content-card">
                  <p>
                    The school aims at the education of the Christian community
                    around and extends its service to members of the other
                    communities admitted to this institution. The school stands
                    for academic excellence, development of skills and character
                    formation based on the love of God and the service of
                    mankind as modelled in Jesus Christ. The specific aim of the
                    school is all round development of students which enables
                    them to fulfil their noble role in life, wherever they may
                    be placed.
                    <br />
                    It also creates awareness in the students of the Socio
                    Economic needs of the country, the less privileged in a
                    spirit of sharing, the need for communal harmony and respect
                    for the religion professed by every pupil.The course of
                    instruction prepares the students for the Council For Indian
                    School Certificate Examination, New Delhi (ICSE & ISC).
                  </p>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="col-12 col-xl-4">
              <div className="contact-map-card about-image-card">
                <div className="about-image-wrap">
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/CSSK/public/Images/Patroness.jpg"
                    alt="About School"
                    className="about-main-image img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <Footer />
    </>
  );
}

export default Patroness;
